import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Badge } from "@/components/ui/badge";
import { rupee } from "./format";

export const TxnDialog = ({ data, onClose }) => (
  <Dialog open={!!data} onOpenChange={(o) => { if (!o) onClose(); }}>
    <DialogContent className="max-w-4xl max-h-[85vh] overflow-y-auto" data-testid="report-txn-dialog">
      <DialogHeader>
        <DialogTitle>{data?.title} · Total {rupee(data?.total)}</DialogTitle>
      </DialogHeader>
      {data && (data.rows.length === 0 ? <div className="text-sm text-slate-500 py-6 text-center">No entries.</div> : (
        <table className="w-full text-xs">
          <thead className="bg-slate-50 uppercase text-slate-500">
            <tr>{["Month", "Date", "Source", "Payee", "RKF ref", "Vendor bill no", "Sub-type", "Status", "Amount", ""].map(h => <th key={h} className="text-left px-2 py-1.5">{h}</th>)}</tr>
          </thead>
          <tbody>
            {data.rows.map(r => (
              <tr key={`${r.source}-${r.id}`} className="border-b" data-testid={`report-txn-row-${r.id}`}>
                <td className="px-2 py-1.5 font-mono">{r.month}{r.month_inferred && <span title="No Expense Month – taken from invoice date" className="text-amber-600">*</span>}</td>
                <td className="px-2 py-1.5">{r.date || "–"}</td>
                <td className="px-2 py-1.5"><Badge variant="outline" className="text-[10px]">{r.source}</Badge></td>
                <td className="px-2 py-1.5">{r.payee}</td>
                <td className="px-2 py-1.5 font-mono" data-testid={`report-txn-inv-${r.id}`}>{r.inv_ref || "–"}</td>
                <td className="px-2 py-1.5">{r.invoice_no || "–"}</td>
                <td className="px-2 py-1.5">{r.subtype_code}</td>
                <td className="px-2 py-1.5">{r.status}</td>
                <td className="px-2 py-1.5 text-right font-mono">{rupee(r.invoice_total)}</td>
                <td className="px-2 py-1.5"><a href={r.link} target="_blank" rel="noreferrer" className="text-blue-600 font-semibold" data-testid={`report-txn-link-${r.id}`}>Open</a></td>
              </tr>
            ))}
          </tbody>
        </table>
      ))}
      {data?.rows.some(r => r.month_inferred) && <p className="text-[11px] text-amber-700">* No Expense Month on the record – month taken from the invoice date.</p>}
    </DialogContent>
  </Dialog>
);
